import { ValidationError } from "sequelize"
import {
    CcRequirementHistoryCreate,
    CcRequirementHistory,
    CcRequirementHistoryUpdateResponse,
    CcRequirementHistoryVersion,
    CcRequirementHistoryImportProps,
} from "server/models"
import { GET, POST, validate } from "client/store/utils"
import {
    LangType,
    RequirementHistoryValidation,
} from "client/store"

export const CreateManyCcRequirementHistory = (
    historyArray: CcRequirementHistoryCreate[],
) => (
    POST(
        "/ccRequirementHistory/bulkCreate",
        JSON.stringify(historyArray),
    )
)
export const CreateCcRequirementHistory = (
    history: CcRequirementHistoryCreate,
    lang: LangType,
) => (
    POST(
        "/ccRequirementHistory/create",
        JSON.stringify(history),
    ).then((res) => {
        const newHistory = res as CcRequirementHistory
        const error = res as ValidationError
        const validation = <RequirementHistoryValidation>validate(error, lang)

        return {
            newHistoryId: newHistory.id || null,
            validation,
        }
    })
)
export const CreateCcRequirementHistoryVersions = (versions: CcRequirementHistoryVersion[]) => (
    POST(
        "/ccRequirementHistoryVersion/save",
        JSON.stringify(versions),
    )
)
export const UpdateCcRequirementHistoryResponse = ( // for Super Admin only
    id: number,
    responseId: number,
    lang: LangType,
) => {
    const data: CcRequirementHistoryUpdateResponse = {
        id,
        responseId,
    }
    return POST(
        "/ccRequirementHistory/updateResponse",
        JSON.stringify(data),
    ).then((res) => {
        const error = res as ValidationError
        const validation = <RequirementHistoryValidation>validate(error, lang)
        return validation
    })
}
export const LoadCcRequirementHistory = (requirementId: number, revisionId: number) => (
    GET(`/ccRequirementHistory/requirementId/${requirementId}/revision/${revisionId}`)
    .then((history: CcRequirementHistory[]) => history)
)
export const ImportCcRequirementHistory = (data: CcRequirementHistoryImportProps) => (
    POST(
        "/ccRequirementHistory/import",
        JSON.stringify(data),
    )
)
